(() => {
  const selector = '[data-elizna-before-after]';

  const init = (root) => {
    if (!root || root.dataset.eliznaBaReady === 'true') return;

    const range = root.querySelector('[data-elizna-ba-range]');
    if (!range) return;

    const update = () => {
      const value = Math.max(0, Math.min(100, Number(range.value) || 50));

      root.style.setProperty('--elizna-ba-position', `${value}%`);
      range.setAttribute(
        'aria-valuetext',
        `Before ${value}%, after ${100 - value}%`
      );
    };

    range.addEventListener('input', update);
    range.addEventListener('change', update);

    root.dataset.eliznaBaReady = 'true';

    update();
  };

  const boot = (scope = document) => {
    if (scope.matches?.(selector)) init(scope);

    scope
      .querySelectorAll?.(selector)
      .forEach(init);
  };

  window.EliznaBeforeAfterBoot = boot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document), {
      once: true,
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });
})();